export var InstantSwapFlowModalButtonTypes;
(function (InstantSwapFlowModalButtonTypes) {
    InstantSwapFlowModalButtonTypes["continue"] = "continue";
})(InstantSwapFlowModalButtonTypes || (InstantSwapFlowModalButtonTypes = {}));
export var InstantSwapFlowModalContentTypes;
(function (InstantSwapFlowModalContentTypes) {
    InstantSwapFlowModalContentTypes["confirmation"] = "confirmation";
    InstantSwapFlowModalContentTypes["instantSwapSuccess"] = "instantSwapSuccess";
    InstantSwapFlowModalContentTypes["instantSwapError"] = "instantSwapError";
})(InstantSwapFlowModalContentTypes || (InstantSwapFlowModalContentTypes = {}));
